module.exports = __webpack_public_path__ + "security-circle.2eb_Mqj-.svg";